import React from 'react';
import { useHits, useInstantSearch } from 'react-instantsearch';
import NoResultsBoundary from './NoResultsBoundary';
import SearchProductCard from './ProductCard';
import { Link } from 'gatsby';

export default function ProductHits() {
  const { hits, results, sendEvent } = useHits();
  return (
      <>
        <p className="text-lg ml-2 mb-1 pb-2 font-bold">Products</p>
        <NoResultsBoundary fallback={<p>No products found</p>}>
          <div className="flex flex-wrap">
            {hits.map((hit) => (
              <Link
                key={hit.objectID}
                to={`/products/${hit.objectID}`}
                state={{ queryID: hit.__queryID }}
                className="no-underline text-white box-border w-1/2 lg:w-1/4 min-w-[120px] p-2 mb-2"
                onClick={() => sendEvent('click', hit, 'Product clicked')}
                onAuxClick={() => sendEvent('click', hit, 'Product clicked')}
              >
                <SearchProductCard key={hit.objectID} hit={hit}/>
              </Link>
            ))}
          </div>
          {results.nbHits > 4 && (
            <Link
              className="rounded-full bg-white text-sm mt-[25px] py-[10px] px-8 cursor-pointer flex items-center justify-center h-[42px] text-[#1f1f1f] font-bold"
              to={`/search?q=${encodeURIComponent(results.query)}`}
            >
              View all {results.nbHits} products
            </Link>
          )}
        </NoResultsBoundary>
      </>
  );
}
